import { createAction } from 'redux-actions'

const defaultPrefix = 'GAIO/'
let prefix = defaultPrefix

export const initialLoad = createAction(`${prefix}INITIAL_LOAD`)
export const resetState = createAction(`${prefix}RESET_STATE`)

// DATA
prefix = `${defaultPrefix}DATA/`

export const createProjectStart = createAction(`${prefix}CREATE_PROJECT_START`)
export const createProjectSuccess = createAction(`${prefix}CREATE_PROJECT_SUCCESS`)
export const createProjectError = createAction(`${prefix}CREATE_PROJECT_ERROR`)

export const updateProjectStart = createAction(`${prefix}UPDATE_PROJECT_START`)
export const updateProjectSuccess = createAction(`${prefix}UPDATE_PROJECT_SUCCESS`)
export const updateProjectError = createAction(`${prefix}UPDATE_PROJECT_ERROR`)

export const deleteProjectStart = createAction(`${prefix}DELETE_PROJECT_START`)
export const deleteProjectSuccess = createAction(`${prefix}DELETE_PROJECT_SUCCESS`)
export const deleteProjectError = createAction(`${prefix}DELETE_PROJECT_ERROR`)

export const createPromptStart = createAction(`${prefix}CREATE_PROMPT_START`)
export const createPromptSuccess = createAction(`${prefix}CREATE_PROMPT_SUCCESS`)
export const createPromptError = createAction(`${prefix}CREATE_PROMPT_ERROR`)

export const updatePromptStart = createAction(`${prefix}UPDATE_PROMPT_START`)
export const updatePromptSuccess = createAction(`${prefix}UPDATE_PROMPT_SUCCESS`)
export const updatePromptError = createAction(`${prefix}UPDATE_PROMPT_ERROR`)

export const deletePromptStart = createAction(`${prefix}DELETE_PROMPT_START`)
export const deletePromptSuccess = createAction(`${prefix}DELETE_PROMPT_SUCCESS`)
export const deletePromptError = createAction(`${prefix}DELETE_PROMPT_ERROR`)

export const searchProjectsStart = createAction(`${prefix}SEARCH_PROJECTS_START`)
export const searchProjectsSuccess = createAction(`${prefix}SEARCH_PROJECTS_SUCCESS`)
export const searchProjectsError = createAction(`${prefix}SEARCH_PROJECTS_ERROR`)

export const fetchProjectsCountStart = createAction(`${prefix}FETCH_PROJECTS_COUNT_START`)
export const fetchProjectsCountSuccess = createAction(`${prefix}FETCH_PROJECTS_COUNT_SUCCESS`)
export const fetchProjectsCountError = createAction(`${prefix}FETCH_PROJECTS_COUNT_ERROR`)

export const searchPromptsStart = createAction(`${prefix}SEARCH_PROMPTS_START`)
export const searchPromptsSuccess = createAction(`${prefix}SEARCH_PROMPTS_SUCCESS`)
export const searchPromptsError = createAction(`${prefix}SEARCH_PROMPTS_ERROR`)

export const fetchPromptsStatisticsStart = createAction(`${prefix}FETCH_PROMPTS_STATISTICS_START`)
export const fetchPromptsStatisticsSuccess = createAction(`${prefix}FETCH_PROMPTS_STATISTICS_SUCCESS`)
export const fetchPromptsStatisticsError = createAction(`${prefix}FETCH_PROMPTS_STATISTICS_ERROR`)

export const fetchPromptOptionsStart = createAction(`${prefix}FETCH_PROMPT_OPTIONS_START`)
export const fetchPromptOptionsSuccess = createAction(`${prefix}FETCH_PROMPT_OPTIONS_SUCCESS`)
export const fetchPromptOptionsError = createAction(`${prefix}FETCH_PROMPT_OPTIONS_ERROR`)

export const searchPromptStart = createAction(`${prefix}SEARCH_PROMPT_START`)
export const searchPromptSuccess = createAction(`${prefix}SEARCH_PROMPT_SUCCESS`)
export const searchPromptError = createAction(`${prefix}SEARCH_PROMPT_ERROR`)

export const searchTagsStart = createAction(`${prefix}SEARCH_TAGS_START`)
export const searchTagsSuccess = createAction(`${prefix}SEARCH_TAGS_SUCCESS`)
export const searchTagsError = createAction(`${prefix}SEARCH_TAGS_ERROR`)

export const fetchSuggestedPromptsStart = createAction(`${prefix}FETCH_SUGGESTED_PROMPTS_START`)
export const fetchSuggestedPromptsSuccess = createAction(`${prefix}FETCH_SUGGESTED_PROMPTS_SUCCESS`)
export const fetchSuggestedPromptsError = createAction(`${prefix}FETCH_SUGGESTED_PROMPTS_ERROR`)

export const fetchPromptNewsStart = createAction(`${prefix}FETCH_PROMPT_NEWS_START`)
export const fetchPromptNewsSuccess = createAction(`${prefix}FETCH_PROMPT_NEWS_SUCCESS`)
export const fetchPromptNewsError = createAction(`${prefix}FETCH_PROMPT_NEWS_ERROR`)

export const sourcesRequestStart = createAction(`${prefix}SOURCES_REQUEST_START`)
export const sourcesRequestSuccess = createAction(`${prefix}SOURCES_REQUEST_SUCCESS`)
export const sourcesRequestError = createAction(`${prefix}SOURCES_REQUEST_ERROR`)

export const scorecardRequestStart = createAction(`${prefix}SCORECARD_REQUEST_START`)
export const scorecardRequestSuccess = createAction(`${prefix}SCORECARD_REQUEST_SUCCESS`)
export const scorecardRequestError = createAction(`${prefix}SCORECARD_REQUEST_ERROR`)

export const requestSubscriptionChangeStart = createAction(`${prefix}REQUEST_SUBSCRIPTION_CHANGE_START`)
export const requestSubscriptionChangeSuccess = createAction(`${prefix}REQUEST_SUBSCRIPTION_CHANGE_SUCCESS`)
export const requestSubscriptionChangeError = createAction(`${prefix}REQUEST_SUBSCRIPTION_CHANGE_ERROR`)

export const setSelectedPrompt = createAction(`${prefix}SET_SELECTED_PROMPT`)

// UI
prefix = `${defaultPrefix}UI/`

export const openCreateView = createAction(`${prefix}OPEN_CREATE_VIEW`)
export const closeCreateView = createAction(`${prefix}CLOSE_CREATE_VIEW`)

export const setSelectedProject = createAction(`${prefix}SET_SELECTED_PROJECT`)
export const setHasProjects = createAction(`${prefix}SET_HAS_PROJECTS`)
export const setPromptsPage = createAction(`${prefix}SET_PROMPTS_PAGE`)
export const setPromptsLimit = createAction(`${prefix}SET_PROMPTS_LIMIT`)
export const setPromptNewsPage = createAction(`${prefix}SET_PROMPT_NEWS_PAGE`)
export const setPromptNewsLimit = createAction(`${prefix}SET_PROMPT_NEWS_LIMIT`)
export const setProjectSearchInputValue = createAction(`${prefix}SET_PROJECT_SEARCH_INPUT_VALUE`)
export const setPromptsFilters = createAction(`${prefix}SET_PROMPTS_FILTERS`)
export const setSuggestionsVisible = createAction(`${prefix}SET_SUGGESTIONS_VISIBLE`)

export const openPromptCreateDialog = createAction(`${prefix}OPEN_PROMPT_CREATE_DIALOG`)
export const openPromptEditDialog = createAction(`${prefix}OPEN_PROMPT_EDIT_DIALOG`)
export const closePromptFormDialog = createAction(`${prefix}CLOSE_PROMPT_FORM_DIALOG`)
export const setPromptFormField = createAction(`${prefix}SET_PROMPT_FORM_FIELD`)
export const openPromptDeleteDialog = createAction(`${prefix}OPEN_PROMPT_DELETE_DIALOG`)
export const closePromptDeleteDialog = createAction(`${prefix}CLOSE_PROMPT_DELETE_DIALOG`)

export const openProjectEditDialog = createAction(`${prefix}OPEN_PROJECT_EDIT_DIALOG`)
export const closeProjectEditDialog = createAction(`${prefix}CLOSE_PROJECT_EDIT_DIALOG`)
export const setProjectFormField = createAction(`${prefix}SET_PROJECT_FORM_FIELD`)
export const openProjectDeleteDialog = createAction(`${prefix}OPEN_PROJECT_DELETE_DIALOG`)
export const closeProjectDeleteDialog = createAction(`${prefix}CLOSE_PROJECT_DELETE_DIALOG`)
